// AUTO-GENERATED from legacy specifications/vendors/<id>/vendor.html "EDI
// Information" blocks. Keyed by partner id (matches PARTNER_SPECS). Rendered by
// SpecificationDetail.jsx when EDI_INFO[partner.id] exists. Re-run the
// extraction script to regenerate; do not hand-edit.
export const EDI_INFO = {
  "arnecom": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ID",
          "value": "ARNECOM"
        }
      ],
      "head": "Arnecom"
    }
  ],
  "aunde": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "UNB ID",
          "value": "812516995"
        },
        {
          "label": "UNB Qualifier",
          "value": "01"
        }
      ]
    }
  ],
  "awtec": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Sterling Commerce"
        },
        {
          "label": "ISA Qualifier",
          "value": "12"
        },
        {
          "label": "ISA ID",
          "value": "7344541710"
        },
        {
          "label": "GS ID",
          "value": "7344541710"
        }
      ],
      "head": "AwTec"
    }
  ],
  "Daechang": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN15429"
        },
        {
          "label": "GS ID",
          "value": "ICN15429"
        }
      ]
    }
  ],
  "dana": [
    {
      "pairs": [
        {
          "label": "ISA Qualifier",
          "value": "01"
        },
        {
          "label": "ISA ID",
          "value": "005470885"
        },
        {
          "label": "GS ID",
          "value": "005470885"
        }
      ],
      "head": "Dana Light Axle"
    },
    {
      "pairs": [
        {
          "label": "ISA Qualifier",
          "value": "01"
        },
        {
          "label": "ISA ID",
          "value": "Plant DUNS #"
        },
        {
          "label": "GS ID",
          "value": "Plant DUNS #"
        }
      ],
      "head": "Dana Driveshaft"
    }
  ],
  "edminiat": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN10567"
        },
        {
          "label": "GS ID",
          "value": "ICN10567"
        }
      ],
      "head": "Ed Miniat"
    }
  ],
  "EnterpriseElectronics": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN17381"
        },
        {
          "label": "GS ID",
          "value": "ICN17381"
        }
      ],
      "head": "Enterprise Electronics"
    }
  ],
  "freightcaramerica": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN13481"
        },
        {
          "label": "GS ID",
          "value": "ICN13481"
        }
      ],
      "head": "FreightCar America"
    }
  ],
  "harristeeter": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Inovis"
        },
        {
          "label": "ISA Qualifier",
          "value": "01"
        },
        {
          "label": "ISA ID",
          "value": "047279351"
        },
        {
          "label": "GS ID",
          "value": "047279351"
        }
      ],
      "head": "Production IDs"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Inovis"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "HTTEST"
        },
        {
          "label": "GS ID",
          "value": "HTTEST"
        }
      ],
      "head": "Test IDs"
    }
  ],
  "hillrom": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Sterling Commerce"
        },
        {
          "label": "ISA Qualifier",
          "value": "12"
        },
        {
          "label": "ISA ID",
          "value": "8437408054"
        },
        {
          "label": "GS ID",
          "value": "8437408054"
        }
      ],
      "head": "Production IDs"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Sterling Commerce"
        },
        {
          "label": "ISA Qualifier",
          "value": "12"
        },
        {
          "label": "ISA ID",
          "value": "8129341372SFTP"
        },
        {
          "label": "GS ID",
          "value": "8129341372SFTP"
        }
      ],
      "head": "Test IDs"
    }
  ],
  "iljinsc": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN11574"
        },
        {
          "label": "GS ID",
          "value": "ICN11574"
        }
      ],
      "head": "Iljin South Carolina"
    }
  ],
  "inoacexteriorproducts": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "Qualifier",
          "value": "01"
        },
        {
          "label": "ID",
          "value": "056894041"
        }
      ],
      "head": "INOAC Exterior Products, L.L.C."
    }
  ],
  "kroger": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "Sterling"
        },
        {
          "label": "ISA Qualifier",
          "value": "08"
        },
        {
          "label": "ISA ID",
          "value": "9254110060"
        },
        {
          "label": "GS ID",
          "value": "5137624388"
        }
      ],
      "head": "Kroger"
    }
  ],
  "KwangJin": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN10566"
        },
        {
          "label": "GS ID",
          "value": "ICN10566"
        }
      ],
      "head": "Kwang Jin America"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN11409"
        },
        {
          "label": "GS ID",
          "value": "ICN11409"
        }
      ],
      "head": "Kwang Jin Mexico"
    }
  ],
  "nemak": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN3987"
        },
        {
          "label": "GS ID",
          "value": "ICN3987"
        }
      ],
      "head": "Nemak WIS / KTY Plants"
    }
  ],
  "saautomotive": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN12433"
        },
        {
          "label": "GS ID",
          "value": "ICN12433"
        }
      ],
      "head": "SA Automotive"
    }
  ],
  "strattec": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "STRATTEC"
        },
        {
          "label": "GS ID",
          "value": "STRATTEC"
        }
      ],
      "head": "ANSI X12 Information"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "UNB Qualifier",
          "value": "ZZ"
        },
        {
          "label": "UNB ID",
          "value": "STRATTEC"
        }
      ],
      "head": "EDIFACT Information"
    }
  ],
  "tacle": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "GXS"
        },
        {
          "label": "ISA Qualifier",
          "value": "01"
        },
        {
          "label": "ISA ID",
          "value": "614823040"
        },
        {
          "label": "GS ID",
          "value": "614823040"
        }
      ],
      "head": "Tacle Seating USA"
    }
  ],
  "TALLERES": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "EPKRCS"
        },
        {
          "label": "GS ID",
          "value": "EPKRCS"
        }
      ],
      "head": "TALLERES MECANICOS MONTSERRAT"
    }
  ],
  "toyoda": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN15354"
        },
        {
          "label": "GS ID",
          "value": "ICN15354"
        }
      ],
      "head": "Toyoda"
    }
  ],
  "tsmcorp": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN9803"
        },
        {
          "label": "GS ID",
          "value": "ICN9803"
        }
      ],
      "head": "TSM Corporation"
    }
  ],
  "unisia": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "ICN0974"
        },
        {
          "label": "GS ID",
          "value": "ICN0974"
        }
      ],
      "head": "Unisia of Georgia"
    }
  ],
  "universallighting": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "01"
        },
        {
          "label": "ISA ID",
          "value": "024872470"
        },
        {
          "label": "GS ID",
          "value": "024872470"
        }
      ],
      "head": "Universal Lighting Technologies"
    }
  ],
  "yokohama": [
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "YHAMERICAS"
        },
        {
          "label": "GS ID",
          "value": "YHAMERICAS"
        }
      ],
      "head": "Yokohama Industries Americas, Inc (Production)"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "YHAMERICAST"
        },
        {
          "label": "GS ID",
          "value": "YHAMERICAST"
        }
      ],
      "head": "Yokohama Industries Americas, Inc (Testing)"
    },
    {
      "pairs": [
        {
          "label": "VAN",
          "value": "iConnect"
        },
        {
          "label": "ISA Qualifier",
          "value": "ZZ"
        },
        {
          "label": "ISA ID",
          "value": "YOKOHAMAMX"
        },
        {
          "label": "GS ID",
          "value": "YOKOHAMAMX"
        }
      ],
      "head": "Yokohama Industries Americas, Inc (Mexico)"
    }
  ]
};
